import React from 'react';
import { getText } from '../../../../../services/text/text-service';
import { LeadText, Title } from '@gje/typography/lib';

interface HeaderProps {
    customerName: string;
}

export const SecondStepHeader: React.FunctionComponent<HeaderProps> = ({
    customerName
}) => {
    return (
        <div className={`text-center healthcare-step-header row`}>
            <div className={'col-sm-1-5'} />
            <div className={'col-sm-20'}>
                <Title tag="h2" className="margin-bottom-39">
                    Hej {customerName}!
                </Title>
                <LeadText className={'title-without-bold'}>
                    {getText(
                        'webshopsweden.products.employeeHealthcare.buyingHeader'
                    )}
                </LeadText>
            </div>
            <div className={'col-sm-1-5'} />
        </div>
    );
};

export default SecondStepHeader;
